import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PrecisionManufacturingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"precision_manufacturing"}/>
}
